module.exports = __webpack_public_path__ + "img/75.9077b483.png";